import Vue from "vue";
import router from "@/router";

export function checkWechatLogin(teacher_id) {
    let openid = Vue.ls.get("user_openid_new");

    if (isWechat() && openid == null) {
        router.replace({
            name: "wxlogin",
            query: {
                teacher_id: teacher_id,
            },
        });
    }
}

export function isWechat() {
    return /MicroMessenger/i.test(window.navigator.userAgent);
}